import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";
import { SavaneCookie } from "@rhinov/savane-js";

export class NameFilter implements IFilter {

    id: string;
    name?: string | null;
    type: string;
    parentGroup: FilterGroup;
    controller: FiltersController;

    constructor(parentGroup: FilterGroup) {
        this.id = 'name';
        this.name = 'Recherche';
        this.type = 'name';

        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    toggleSmartSearch(): void {
        if (!FilterGroup.smartSearch()) {
            FilterGroup.smartSearchActivated = 1;
            SavaneCookie.setCookie("Rhinov-DesignerFilter-SmartSearchEnabled", "" + 1);
        }
        else {
            FilterGroup.smartSearchActivated = 0;
            SavaneCookie.setCookie("Rhinov-DesignerFilter-SmartSearchEnabled", "" + 0);
        }
        FilterGroup.updateFilters(FilterGroup.filters);
    };

    updateToggleHtml(): void {
        const container = document.getElementById('smartSearchToggle');
        if (container) {
            container.innerHTML = `
            <span class="fa-stack">
                <i class="fas fa-stack-1x fa-search-plus" style="line-height: 2em;"></i>
                ${!FilterGroup.smartSearch() ? '<i class="fas fa-ban fa-stack-2x" style="color:Tomato"></i>' : ''}
            </span>
            `;
        }
    }

    toggleHtml(): string {
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            this.controller.addEventListener('click', () => {
                this.toggleSmartSearch();
                this.updateToggleHtml();
            }, 'smartSearchToggle');
        });

        return `
            <div id="smartSearchToggle" style="cursor: pointer; padding: 0;" class="col-xs-1">
                <span class="fa-stack">
                    <i class="fas fa-stack-1x fa-search-plus" style="line-height: 2em;"></i>
                    ${!FilterGroup.smartSearch() ? '<i class="fas fa-ban fa-stack-2x" style="color:Tomato"></i>' : ''}
                </span>
            </div>
        `;
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;flex-direction: column;align-items: center;margin:0 auto;max-width: 380px;width: 100%;">
            <div class="row" style="width: 100%;">
                <span>${this.name}</span>
                <div class="col-xs-10" style="padding: 0;height:30px">
                    <input id="nameInput" style="max-width: 380px;width: 100%;margin:0 auto;height : 100%;border:1px solid #ccc;"
                        type="text" value="` + (FilterGroup.filters.name ? FilterGroup.filters.name : "") + `">
                </div>
                ${this.toggleHtml()}
            </div>
        </div>
        `;
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            this.controller.addEventListener('input', () => {
                let val = $('#nameInput').val() as string;
                FilterGroup.filters.name = val.trim();
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            }, 'nameInput');
        });
        return html;
    }

    generateStringFilter(): string {
        return("");
    }

    destroy(): void {
        this.controller.destroy();
    }
}